module.exports = __webpack_public_path__ + "static/genuss-tablet-3528ba48a35da1a5f84c3e70cf145523.jpg";